<template>
  <div class="block-wrapper">
    <div class="block-container"
         v-for="(item,index) in blockInfo"
         :key="index + item.id">
      <h3>{{item.name}}</h3>
      <div class="item-container"
           :class="item.template == 'still' ? 'still-container' : 'poster-container' "
           ref="blockbox">
        <div class="item "
             :class="item.template == 'still' ? 'still-item' : '' "
             v-for="(val, ind) in item.contents"
             :key="ind + val.mid"
             @click="handlePlay(val.mid)"
             :data-mid="val.mid"
             :data-vid="val.vid"
             :data-stp="val.stp"
             :data-template="item.template"
             :data-blockid="item.id">
          <div class="pic">
            <img v-if="item.template == 'still'"
                 :src="val.still"
                 alt=""
                 srcset="">
            <img v-if="item.template == 'poster'"
                 :src="val.poster"
                 alt=""
                 srcset="">
            <span class="icon"
                  v-if="val.isvip == 1"></span>
          </div>
          <p class="name"
             :title="val.name">{{val.name}}</p>
          <p class="desc">{{val.aword}}</p>
        </div>
      </div>
      <div v-if="index===0" class="_um32i2mvbkt" style="text-align: center;margin: 25px 0;"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CommonBlock',
  props: {
    blockInfo: {
      type: Array,
      default: () => []
    },
    channel_id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      rownum: 8,
      screenWidth: document.body.clientWidth
    }
  },
  watch: {
    screenWidth (val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        // this.screenWidth = val
        this.fixRow()
        this.timer = true
        let that = this
        setTimeout(function () {
          // 打印screenWidth变化的值
          // console.log(that.screenWidth)
          that.timer = false
        }, 0)
      }
    },
    // $route(){
    //     this.fixRow(this.blockInfo)
    // },
    blockInfo (val, newval) {
      this.$nextTick(() => {
        this.fixRow()
      })
    }
  },
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {
    this.fixRow()
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
  },
  methods: {
    handlePlay (mid) {
      window.open('/player/?mid=' + mid + '&cid=' + this.channel_id)
      // this.$router.push('/play/')
    },
    fixRow () {
      if (this.blockInfo.length == 0) return
      if (document.body.clientWidth < 1633) {
        this.rownum = 6
      } else if (document.body.clientWidth < 1900) {
        this.rownum = 7
      }
      this.blockInfo.forEach((item, index) => {
        let step = Math.floor(item.contents.length / this.rownum)
        if (item.template == 'still') {
          this.$refs.blockbox[index].style.height = 178 * step + 'px'
        }
        if (item.template == 'poster') {
          this.$refs.blockbox[index].style.height = 329 * step + 'px'
        }
      })
    }
  }
}
</script>
<style lang="less">
.block-wrapper {
  text-align: left;
  h3 {
    font-size: 28px;
    font-weight: 500;
    // line-height: 42px;
    color: #fff;
    text-align: left;
    margin-top: 36px;
    margin-bottom: 12px;
  }
  .item-container {
    .item {
      display: inline-block;
      cursor: pointer;
      margin: 12px 24px 12px 0px;
      .pic {
        width: 180px;
        height: 252px;
        // padding-bottom: 140%;
        border-radius: 4px;
        overflow: hidden;
        position: relative;
        img {
          display: block;
          width: 100%;
          height: 100%;
          &:hover {
            animation: mymove 0.5s ease-in-out 1;
            /*Safari 和 Chrome:*/
            -webkit-animation: mymove 0.5s ease-in-out 1;
          }
        }
        @keyframes mymove {
          from {
            transform: scale(1);
          }
          to {
            transform: scale(1.1);
          }
        }
        .icon {
          position: absolute;
          top: 4px;
          right: 4px;
          width: 34px;
          height: 20px;
          background: url('./../assets/imgs/icon-vip.png') no-repeat;
          background-size: contain;
        }
      }
      .name {
        font-size: 16px;
        color: #fff;
        font-weight: 500;
        line-height: 24px;
        text-align: left;
        width: 180px;
        margin-top: 8px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        &:hover {
          color: #0184ff;
        }
      }
      .desc {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.5);
        line-height: 21px;
        text-align: left;
        width: 180px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .still-item {
      .pic {
        height: 101px;
      }
    }
  }
  .still-container {
    // height: 340px;
    overflow: hidden;
  }
  .poster-container {
    // height: 642px;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CommonBlock.vue